// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__2Qbce","header":"style_header__f5Wll","title":"style_title__ve2m_"};